// Stimulus controller that bridges an ERB mount point to the
// template editor Vue app.
//
// Data flow:
//   dashboard#template_editor (ERB) -> data-* attrs -> this controller
//   -> Vue createApp -> ~/javascript/components/template_editor/index.vue
//
// All editor state mutation goes through ajax endpoints in
// app/controllers/ajax/template_*_controller.rb.

import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import TemplateEditor from '~/javascript/components/template_editor/index.vue'

export default class extends Controller {
  static values = {
    payload: { type: Object, default: {} },
    csrf: { type: String, default: '' },
    websiteId: { type: String, default: '' }
  }

  connect() {
    this.vue = createApp(TemplateEditor, {
      initialPayload: this.payloadValue,
      csrfToken: this.csrfValue,
      websiteId: this.websiteIdValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    if (this.vue) {
      this.vue.unmount()
      this.vue = null
    }
  }
}
